














import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import MenuList from './components/menuList.vue';

@Component({
  components: {
    MenuList,
  },
})
export default class MenuDrawer extends Vue {
  get visible() {
    return AppModule.menuDrawer.visible;
  }
  private onClose() {
    AppModule.ToggleMenuDrawerVisible();
  }
}
